import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useWebSocket } from 'context/WebSocketContext';
import { addNewNotification } from 'slices/chat/reducer';
import dayjs from 'dayjs';
import { getNotificationThunk } from 'slices/chat/thunk';

/**
 * WebSocketNotificationListener Component
 * 
 * This component listens for WebSocket notifications and dispatches them to the Redux store.
 * It should be mounted once at the application root level to ensure notifications are captured
 * regardless of which page the user is on.
 */
const WebSocketNotificationListener = () => {
    const dispatch = useDispatch();
    const { subscribe } = useWebSocket();

    const handleNotification = useCallback((data) => {
        try {
            // Parse the data if it's a string
            const notificationData = typeof data === 'string' ? JSON.parse(data) : data;

            // Create notification object with proper formatting
            console.log("New Notification Data", notificationData)
            const newNotification = {
                message: notificationData?.data || notificationData?.message || 'New notification received',
                time: dayjs().format("MMM D, YYYY [at] h:mm A"),
                event: notificationData?.event ?? "notification"
            };

            // Dispatch to add the notification to the store
            dispatch(addNewNotification(newNotification));
        } catch (error) {
            console.error('Error processing WebSocket notification:', error);
        }
    }, [])

    useEffect(() => {
        dispatch(getNotificationThunk());
    }, [dispatch]);


    useEffect(() => {
        // Subscribe to form_event notifications
        const formEventUnsubscribe = subscribe('form_event', handleNotification);
        const meetEventUnsubscribe = subscribe('meet_event', handleNotification); // This is wrong Key
        const notificationCheckUnsubscribe = subscribe('notification_check', handleNotification);
        // Cleanup subscription when component unmounts
        return () => {
            if (formEventUnsubscribe) formEventUnsubscribe();
            if (meetEventUnsubscribe) meetEventUnsubscribe();
            if(notificationCheckUnsubscribe) notificationCheckUnsubscribe();
        };
    }, [dispatch, subscribe]);

    // This component doesn't render anything
    return null;
};

export default WebSocketNotificationListener;